import { render, staticRenderFns } from "./HealthIcon.vue?vue&type=template&id=19d11615"
import script from "./HealthIcon.vue?vue&type=script&lang=js"
export * from "./HealthIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports